import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Offcanvas, Nav, Navbar, Button, Image, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { LoginManager } from '../../../core/login-manager';
import avatars from '../../../core/avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../../assets/logo.svg';


export default function HeaderBlock() {

    const [userInfo, setUserInfo] = useState(null);
    let location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        console.log('location: ', location)
        var element = document.getElementById("app-container");
        element.setAttribute("data-page", location.pathname);
    }, [location]);


    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);

        var headerOffcanvas = document.getElementById("responsive-header-navbar");
        if (headerOffcanvas.classList.contains('show')) {
            console.log('closing menu')
            var closeBtn = document.querySelector("#responsive-header-navbar .offcanvas-header .btn-close");
            closeBtn.click()
        }


    }, [location.pathname]);


    useEffect(() => {
        async function init() {
            var u = LoginManager.getUserInfo()
            setUserInfo(u)
            console.log(u)
        }
        init()
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            // Check if scroll position is greater than 150px
            if (window.scrollY > 150) {
                document.body.classList.add('scrolled');
            } else {
                document.body.classList.remove('scrolled');
            }
        };

        if (location && location.pathname === "/") {
            // Attach the scroll event listener
            document.body.classList.remove('scrolled');
            window.addEventListener('scroll', handleScroll);
        } else {
            document.body.classList.add('scrolled');
        }

        // Cleanup: Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location]);



    return (
        <>
            {location && location.pathname === '/' ? (
                <div id="luna_bordo"></div>
            ) : null}
            <Navbar expand="xxl" collapseOnSelect bg="white" variant="light" sticky="top" id="header-navbar" className='text-light px-3 py-3' style={{ borderBottom: '0.5px solid transparent' }}>
                <Container fluid>
                    <Navbar.Brand>
                        <Image src={logo} height={50} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-header-navbar" />

                    <Navbar.Offcanvas id="responsive-header-navbar" placement="end" className='text-dark'>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                                Ciao, {userInfo && userInfo.name} {userInfo && userInfo.surname}
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="me-auto" id="header-menu" style={{ fontWeight: '300', fontFamily: 'Montserrat, sans-serif' }}>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/' ? '600' : '300' }} to="/">{LanguageProvider.get('header.home')}</Nav.Link>
                                {/* <Nav.Link as={Link} style={{fontWeight: location && location.pathname === '/continua' ? '600' : '300'}} to="/continua">{LanguageProvider.get('header.continue')}</Nav.Link> */}
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/corsi' ? '600' : '300' }} to="/corsi">{LanguageProvider.get('header.courses')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/eventi' ? '600' : '300' }} to="/eventi">{LanguageProvider.get('header.events')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/convegni' ? '600' : '300' }} to="/convegni">{LanguageProvider.get('header.convegni')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/pubblicazioni' ? '600' : '300' }} to="/pubblicazioni">{LanguageProvider.get('header.pubblicazioni')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/associati' ? '600' : '300' }} to="/associati">{LanguageProvider.get('header.associazioni')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/materie' ? '600' : '300' }} to="/materie">{LanguageProvider.get('header.materia')}</Nav.Link>
                                <Nav.Link as={Link} style={{ fontWeight: location && location.pathname === '/profilo' ? '600' : '300' }} className={'d-block d-md-none'} to="/profilo">{LanguageProvider.get('header.profile')}</Nav.Link>
                            </Nav>
                            <Nav>
                                {userInfo && userInfo ? (
                                    <div className='d-flex align-items-center'>
                                        <Button className='rounded-pill me-5' style={{ backgroundColor: 'white', color: 'var(--preimry-color)' }} as={Link} to='/ricerca'>Cerca<FontAwesomeIcon className='ms-2' icon='search'></FontAwesomeIcon></Button>
                                        <p className='text-black mb-0 me-4 d-md-block d-none'>{userInfo.name} {userInfo.surname}</p>
                                        <Image className="rounded-circle me-4 d-md-block d-none" src={avatars[userInfo.avatar]} width={40} height={40} onClick={() => navigate('/profilo')} />
                                    </div>

                                ) : (
                                    <Image className="rounded-circle" src={avatars[0]} width={40} height={40} onClick={() => navigate('/profilo')} />
                                )}
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </>
    );
};